// leaf-town - the hero: movement, swipe, bash, sudo, fireflies
(function () {
  'use strict';
  const G = window.G, T = 16, S = G.SPR, C = G.COL;
  const RUN = 118, ACC = 1150, DEC = 1500, AIR_ACC = 840, AIR_DEC = 480;
  const JUMP = 300, G_UP = 830, G_DOWN = 1250, MAXFALL = 310, COYOTE = 0.1, BUFFER = 0.12;
  const WALL_SLIDE = 52, WJ_X = 165, WJ_Y = 285, WJ_LOCK = 0.15;
  const DASH_SPEED = 320, DASH_T = 0.15, DASH_CD = 0.2, DJUMP = 272, POGO = 262;
  const NOINPUT = { down: {}, pressed: {}, released: {} };
  const QUIPS = ['Ouch!', 'Hey, that stings!', "I'm fine. I'm fine!", 'Rude!'];

  class Agent {
    constructor(p, i) { this.p = p; this.i = i; this.x = p.x; this.y = p.y - 10; this.cd = 0.3; this.life = 11; this.t = i * 2; this.target = null; this.trail = []; }
    update(dt) {
      const p = this.p, L = p.L;
      this.t += dt; this.life -= dt; this.cd -= dt;
      let tx = p.x + p.w / 2 + Math.cos(this.t * 2.4 + this.i * Math.PI) * 20, ty = p.y - 12 + Math.sin(this.t * 3.1 + this.i * 2) * 6;
      if (!this.target || this.target.dead || this.cd > 0.5) this.target = null;
      if (!this.target && this.cd <= 0) {
        let best = 150;
        for (const e of L.ents) {
          if (e.dead || e.noHit || e.noAgent) continue;
          for (const b of e.hurtboxes()) {
            const d = G.dist(p.x, p.y, b.x + b.w / 2, b.y + b.h / 2);
            if (d < best) { best = d; this.target = e; this.box = b; }
          }
        }
      }
      let speed = 5;
      if (this.target) {
        const b = this.target.hurtboxes()[0] || this.box;
        tx = b.x + b.w / 2; ty = b.y + b.h / 2; speed = 11;
        if (G.dist(this.x, this.y, tx, ty) < 9 && this.cd <= 0) {
          const res = this.target.hit(1, Math.sign(tx - p.x) || 1, 0, 'agent', b);
          this.cd = 0.85;
          if (res) { L.spark(this.x, this.y, '#ffe2c4', 6); G.audio.sfx('agentHit'); L.stop(0.02); }
          this.target = null;
        }
      }
      this.x = G.damp(this.x, tx, speed, dt); this.y = G.damp(this.y, ty, speed, dt);
      this.trail.push(this.x, this.y); if (this.trail.length > 10) this.trail.splice(0, 2);
    }
    draw(g, cx, cy) {
      for (let i = 0; i < this.trail.length; i += 2) { g.fillStyle = G.rgba('#d6ffb0', 0.12 + i * 0.03); g.fillRect(Math.round(this.trail[i]) - cx - 2, Math.round(this.trail[i + 1]) - cy - 1, 4, 2); }
      if (this.life < 2 && ((this.life * 10) | 0) % 2) return;
      g.drawImage(S.agent[((this.t * 10) | 0) % 2], Math.round(this.x) - cx - 5, Math.round(this.y) - cy - 4);
      G.light(this.x - cx, this.y - cy, 22, '#fff36e', 0.6, 0.25);
    }
  }

  class Player {
    constructor(L, x, y) {
      this.L = L; this.x = x; this.y = y; this.w = 10; this.h = 10; this.vx = 0; this.vy = 0; this.face = 1;
      this.tools = G.save.data.tools;
      this.maxHp = 5; this.hp = this.maxHp;
      this.onGround = false; this.coyote = 0; this.jumpBuf = 0; this.jumping = false;
      this.wallDir = 0; this.wallCoy = 0; this.lastWall = 0; this.lock = 0; this.dropT = 0;
      this.dashT = 0; this.dashCd = 0; this.dashBuf = 0; this.canDash = true; this.dashId = 0; this.dashDx = 1; this.dashDy = 0; this.canDouble = true;
      this.atkT = 0; this.atkCd = 0; this.atkBuf = 0; this.atkId = 0; this.atkDir = 'f'; this.atkFace = 1; this.atkLive = false; this.atkDmg = 1;
      this.inv = 0; this.hurtT = 0; this.dead = false; this.gone = false; this.goneT = 0;
      this.sx = 1; this.sy = 1; this.runT = 0; this.t = 0; this.blinkT = 2; this.ghosts = []; this.ghostT = 0;
      this.ride = null; this.safe = { x, y }; this.prevBottom = y + this.h;
      this.meter = 0; this.agents = []; this.grace = 0; this.frozen = false; this.celebrate = false; this.auto = 0; this.lookT = 0;
    }
    hurtbox() { return { x: this.x + 1, y: this.y + 1, w: this.w - 2, h: this.h - 1 }; }
    atkBox() {
      const R = this.tools.opus ? 30 : 24;
      if (this.atkDir === 'u') return { x: this.x - 8, y: this.y - R + 3, w: this.w + 16, h: R };
      if (this.atkDir === 'd') return { x: this.x - 8, y: this.y + this.h - 3, w: this.w + 16, h: R };
      return { x: this.atkFace > 0 ? this.x + this.w - 4 : this.x + 4 - R, y: this.y - 7, w: R, h: this.h + 12 };
    }
    setSafe(x, y) { this.safe.x = x; this.safe.y = y; }
    addMeter(n) {
      if (!this.tools.agents || this.agents.length) return;
      const was = this.meter;
      this.meter = Math.min(100, this.meter + n);
      if (was < 100 && this.meter >= 100) { this.L.pop(this.x + 5, this.y - 14, 'fireflies ready', '#ffe2c4', true); G.audio.sfx('agent'); }
    }

    update(dt) {
      const L = this.L, I = this.frozen ? NOINPUT : G.input;
      this.t += dt;
      for (let i = this.ghosts.length - 1; i >= 0; i--) { this.ghosts[i].life -= dt; if (this.ghosts[i].life <= 0) this.ghosts.splice(i, 1); }
      for (const a of this.agents) a.update(dt);
      if (this.agents.length && this.agents[0].life <= 0) { for (const a of this.agents) { L.ring(a.x, a.y, 1, 10, '#ffe2c4', 0.25); L.pop(a.x, a.y - 6, '✓ done', C.okHi); } this.agents = []; }
      if (this.dead) return;
      if (this.gone) { this.goneT -= dt; if (this.goneT <= 0) { this.gone = false; this.inv = 1.4; L.ring(this.x + 5, this.y + 5, 2, 18, G.hero().hi, 0.3); } return; }
      if (this.inv > 0) this.inv -= dt;
      if (this.hurtT > 0) this.hurtT -= dt;
      if (this.atkCd > 0) this.atkCd -= dt;
      if (this.dashCd > 0) this.dashCd -= dt;
      if (this.lock > 0) this.lock -= dt;
      if (this.dropT > 0) this.dropT -= dt;
      if (this.grace > 0) this.grace -= dt;
      this.sx = G.damp(this.sx, 1, 14, dt); this.sy = G.damp(this.sy, 1, 14, dt);
      this.blinkT -= dt; if (this.blinkT < -0.12) this.blinkT = G.rand(1.5, 4.5);

      // carried by a moving platform
      if (this.ride) { L.moveX(this, this.ride.dx); this.y = this.ride.y - this.h; }

      let mx = (I.down.right ? 1 : 0) - (I.down.left ? 1 : 0);
      if (this.auto) mx = this.auto;
      const my = (I.down.down ? 1 : 0) - (I.down.up ? 1 : 0);
      if (this.hurtT > 0) mx = 0;
      if (mx && this.dashT <= 0) this.face = mx;
      this.lookT = my && this.onGround && !mx ? this.lookT + dt : 0;

      // --- bash (dash) ---
      if (I.pressed.dash) this.dashBuf = 0.1; else if (this.dashBuf > 0) this.dashBuf -= dt;
      if (this.dashBuf > 0 && this.tools.bash && this.canDash && this.dashCd <= 0 && this.hurtT <= 0) {
        let dx = mx, dy = my;
        if (this.onGround && dy > 0) dy = 0;
        if (!dx && !dy) dx = this.face;
        const n = Math.hypot(dx, dy);
        this.dashDx = dx / n; this.dashDy = dy / n;
        this.dashT = DASH_T; this.dashCd = DASH_T + DASH_CD; this.canDash = false; this.dashId++; this.dashBuf = 0; this.jumping = false;
        if (dx) this.face = Math.sign(dx);
        this.sx = dy && !dx ? 0.7 : 1.45; this.sy = dy && !dx ? 1.4 : 0.65;
        L.stop(0.035); L.shake(0.14); G.audio.sfx('dash');
        L.ring(this.x + 5, this.y + 5, 3, 16, '#fff', 0.2);
      }
      // --- claw ---
      if (I.pressed.attack) this.atkBuf = 0.12; else if (this.atkBuf > 0) this.atkBuf -= dt;
      if (this.atkBuf > 0 && this.atkCd <= 0 && this.dashT <= 0 && this.hurtT <= 0) {
        this.atkBuf = 0; this.atkT = 0.17; this.atkCd = 0.27; this.atkId++; this.atkLive = true;
        this.atkDir = I.down.up ? 'u' : I.down.down && !this.onGround ? 'd' : 'f';
        this.atkFace = this.face; this.atkDmg = this.tools.opus ? 2 : 1;
        G.audio.sfx(this.tools.opus ? 'swipeBig' : 'swipe');
        if (this.atkDir === 'f') { this.sx = 1.15; this.sy = 0.9; }
      }
      if (this.atkT > 0) { this.atkT -= dt; this.atkLive = this.atkT > 0.05; }
      // --- sub-agents ---
      if (I.pressed.special && this.tools.agents) {
        if (this.meter >= 100 && !this.agents.length) {
          this.meter = 0; this.agents = [new Agent(this, 0), new Agent(this, 1)];
          L.ring(this.x + 5, this.y + 5, 4, 34, '#ffe2c4', 0.35); L.pop(this.x + 5, this.y - 16, 'fireflies, go!', '#ffe2c4', true);
          G.audio.sfx('agent'); L.stop(0.05);
        } else if (!this.agents.length) G.audio.sfx('uiBack');
      }

      this.prevBottom = this.y + this.h;
      const wasGround = this.onGround, fallV = this.vy;

      if (this.dashT > 0) {
        this.dashT -= dt;
        this.vx = this.dashDx * DASH_SPEED; this.vy = this.dashDy * DASH_SPEED;
        this.ghostT -= dt;
        if (this.ghostT <= 0) { this.ghostT = 0.022; this.ghosts.push({ x: this.x, y: this.y, life: 0.2, face: this.face, sx: this.sx, sy: this.sy }); }
        // smash through cracked blocks
        const nx = this.x + this.vx * dt, ny = this.y + this.vy * dt;
        for (let ty = Math.floor((ny - 1) / T); ty <= Math.floor((ny + this.h) / T); ty++)
          for (let tx = Math.floor((nx - 1) / T); tx <= Math.floor((nx + this.w) / T); tx++) L.breakTile(tx, ty);
        if (this.dashT <= 0) { this.vx = this.dashDx * RUN * 1.1; this.vy = this.dashDy < 0 ? this.dashDy * 130 : this.dashDy * RUN; }
      } else {
        const target = mx * RUN;
        let acc = this.onGround ? (mx ? ACC : DEC) : (mx ? AIR_ACC : AIR_DEC);
        if (this.lock > 0 && !this.onGround) acc *= 0.2;
        if (Math.abs(this.vx) > RUN && Math.sign(this.vx) === mx) acc = 260;
        this.vx = G.approach(this.vx, target, acc * dt);
        let gr = this.vy < 0 ? G_UP : G_DOWN;
        if (Math.abs(this.vy) < 38 && I.down.jump && !this.onGround) gr *= 0.55;
        this.vy += gr * dt;
        if (!this.onGround && this.wallDir && mx === this.wallDir && this.vy > 0) {
          this.vy = Math.min(this.vy, WALL_SLIDE);
          if (Math.random() < 0.3) L.part(this.x + (this.wallDir > 0 ? this.w : 0), this.y + G.rand(0, this.h), -this.wallDir * G.rand(5, 20), G.rand(-10, 10), 0.25, 1, '#e8e0f0', 0);
        }
        if (this.vy > MAXFALL) this.vy = MAXFALL;
      }

      // --- jumping ---
      if (this.onGround) this.coyote = COYOTE; else this.coyote -= dt;
      if (I.pressed.jump) this.jumpBuf = BUFFER; else if (this.jumpBuf > 0) this.jumpBuf -= dt;
      if (this.wallDir && !this.onGround) { this.wallCoy = 0.09; this.lastWall = this.wallDir; } else this.wallCoy -= dt;
      if (this.jumpBuf > 0 && this.hurtT <= 0) {
        if (I.down.down && this.onGround && this.onOneway()) { this.dropT = 0.2; this.jumpBuf = 0; this.onGround = false; this.coyote = 0; this.y += 1; }
        else if (this.coyote > 0) {
          this.vy = -JUMP; this.coyote = 0; this.jumpBuf = 0; this.jumping = true; this.onGround = false; this.dashT = 0;
          this.sx = 0.72; this.sy = 1.32; L.dust(this.x + 5, this.y + this.h, 4); G.audio.sfx('jump');
          if (this.ride) this.vx += this.ride.dx * 60 * 0.6;
        } else if (this.wallCoy > 0 && this.dashT <= 0) {
          const d = this.lastWall;
          this.vx = -d * WJ_X; this.vy = -WJ_Y; this.lock = WJ_LOCK; this.face = -d; this.jumping = true; this.jumpBuf = 0; this.wallCoy = 0;
          this.sx = 0.75; this.sy = 1.28; L.dust(this.x + (d > 0 ? this.w : 0), this.y + 6, 4, -d); G.audio.sfx('walljump');
        } else if (this.tools.sudo && this.canDouble && this.dashT <= 0) {
          this.vy = -DJUMP; this.canDouble = false; this.jumping = true; this.jumpBuf = 0;
          this.sx = 0.75; this.sy = 1.3; L.ring(this.x + 5, this.y + this.h, 2, 13, '#fff', 0.22); L.dust(this.x + 5, this.y + this.h + 2, 5);
          G.audio.sfx('djump');
        }
      }
      if (this.jumping && this.vy < 0 && !I.down.jump && !this.auto) { this.vy *= 0.45; this.jumping = false; }
      if (this.vy >= 0) this.jumping = false;

      // --- move + collide ---
      const hx = L.moveX(this, this.vx * dt);
      if (hx) { if (this.dashT > 0 && this.dashDy === 0) this.dashT = Math.min(this.dashT, 0.02); this.vx = 0; }
      let hy = L.moveY(this, this.vy * dt, this.dropT > 0);
      this.ride = null;
      if (!hy && this.vy >= 0 && this.dropT <= 0) {
        const pl = L.platUnder(this, this.prevBottom);
        if (pl) { this.y = pl.y - this.h; hy = 1; this.ride = pl; }
      }
      if (hy < 0) {
        // corner correction: slip round a ledge instead of bonking on it
        let slipped = false;
        for (let o = 1; o <= 4 && !slipped; o++) for (const s of [1, -1]) {
          if (!L.boxHitsSolid(this.x + s * o, this.y - 2, this.w, this.h)) { this.x += s * o; slipped = true; break; }
        }
        if (!slipped) { this.vy = 0; this.jumping = false; }
      }
      this.onGround = hy > 0;
      if (this.onGround) {
        if (!wasGround && fallV > 110) { this.sx = 1.3; this.sy = 0.7; L.dust(this.x + 5, this.y + this.h, 5); G.audio.sfx('land', { vol: Math.min(1, fallV / 300) }); }
        this.vy = 0; this.canDash = true; this.canDouble = true;
        // unstable ground
        const ty = Math.floor((this.y + this.h + 1) / T);
        for (let tx = Math.floor(this.x / T); tx <= Math.floor((this.x + this.w - 0.01) / T); tx++) {
          if (L.tile(tx, ty) === G.TILE.CRUMBLE) { const i = ty * L.w + tx; if (!L.crumble.has(i)) L.crumble.set(i, { s: 1, t: 0.42 }); }
        }
        // remember solid footing for hazards
        if (!this.ride && this.hurtT <= 0) {
          const a = L.tile(Math.floor((this.x + 1) / T), ty), b = L.tile(Math.floor((this.x + this.w - 1) / T), ty);
          const ny = Math.floor((this.y + 4) / T), sp = G.TILE.SPIKE_U;
          if ((a === G.TILE.SOLID || a === G.TILE.ONEWAY) && (b === G.TILE.SOLID || b === G.TILE.ONEWAY) && L.tile(Math.floor((this.x - 6) / T), ny) !== sp && L.tile(Math.floor((this.x + this.w + 6) / T), ny) !== sp) this.setSafe(this.x, this.y);
        }
        if (Math.abs(this.vx) > 30) { this.runT += dt * Math.abs(this.vx) / RUN; if (((this.runT * 7) | 0) !== (((this.runT - dt) * 7) | 0) && Math.random() < 0.5) L.dust(this.x + 5 - this.face * 4, this.y + this.h, 1, -this.face); }
        else this.runT = 0;
      }
      // walls
      this.wallDir = 0;
      if (!this.onGround) {
        if (L.boxHitsSolid(this.x + this.w, this.y + 2, 2, this.h - 4)) this.wallDir = 1;
        else if (L.boxHitsSolid(this.x - 2, this.y + 2, 2, this.h - 4)) this.wallDir = -1;
      }
      if (this.celebrate && this.onGround && this.t % 0.7 < dt) { this.vy = -190; this.onGround = false; this.sx = 0.8; this.sy = 1.25; }
    }
    onOneway() {
      const L = this.L, ty = Math.floor((this.y + this.h + 1) / T);
      let any = false;
      for (let tx = Math.floor(this.x / T); tx <= Math.floor((this.x + this.w - 0.01) / T); tx++) {
        if (L.solid(tx, ty)) return false;
        if (L.tile(tx, ty) === G.TILE.ONEWAY) any = true;
      }
      return any || !!this.ride;
    }
    onHit(e, res, b) {
      const L = this.L;
      const hx = G.clamp(this.x + 5 + (this.atkDir === 'f' ? this.atkFace * 14 : 0), b.x, b.x + b.w), hy = G.clamp(this.y + 5 + (this.atkDir === 'u' ? -14 : this.atkDir === 'd' ? 14 : 0), b.y, b.y + b.h);
      if (res === 'block') { L.spark(hx, hy, '#ffffff', 7); G.audio.sfx('clang'); L.stop(0.04); if (this.atkDir === 'f') this.vx = -this.atkFace * 90; }
      else { L.stop(res === 'kill' ? 0.075 : 0.05); L.shake(res === 'kill' ? 0.3 : 0.16); L.spark(hx, hy, '#fff3e4', 6); if (this.atkDir === 'f' && !this.onGround) this.vx -= this.atkFace * 50; this.addMeter(4); }
      if (this.atkDir === 'd') this.bounce(1);
    }
    bounce(k) {
      this.vy = -(G.input.down.jump && !this.frozen ? JUMP * 0.96 : POGO) * k;
      this.jumping = false; this.canDash = true; this.canDouble = true; this.onGround = false; this.sx = 0.8; this.sy = 1.25;
      this.grace = 0.14;                       // a clean bounce never costs a pip
    }
    spring(s) {
      if (s.t > 0.12) return;
      this.vy = -470; this.jumping = false; this.canDash = true; this.canDouble = true; this.onGround = false; this.dashT = 0;
      this.sx = 0.65; this.sy = 1.45; s.t = 0.25;
      this.L.dust(s.x + 6, s.y, 6); G.audio.sfx('spring');
    }
    scatter(vx0, vy0) {
      const L = this.L, bx = this.x + 5, by = this.y + this.h;
      for (const q of G.heroPixels()) {
        if (q.eye) continue;
        L.part(bx + q.x, by + q.y, q.x * G.rand(8, 22) + (vx0 || 0), q.y * G.rand(6, 16) - 60 + (vy0 || 0), G.rand(0.6, 1.1), 1, q.col, 520, { bounce: true, keep: true });
      }
    }
    hurt(d, srcX) {
      if (this.inv > 0 || this.dashT > 0 || this.dead || this.gone || this.celebrate) return false;
      const L = this.L;
      this.hp -= d; L.hits++;
      this.inv = 1.3; this.hurtT = 0.22; this.jumping = false;
      this.vx = (this.x + 5 < srcX ? -1 : 1) * 150; this.vy = -175; this.onGround = false;
      L.stop(0.09); L.shake(0.5); L.flashScreen(0.22, C.hazard);
      L.burst(this.x + 5, this.y + 5, 8, [G.hero().col, G.hero().hi, '#fff'], 120, 300);
      G.audio.sfx('hurt');
      if (this.hp <= 0) this.die();
      else if (Math.random() < 0.22) L.pop(this.x + 5, this.y - 12, G.pick(QUIPS), C.paper, true);
      return true;
    }
    // spikes, liquid and pits: lose a pip, come back on the last solid ground
    hazard() {
      if (this.dead || this.gone || this.celebrate) return;
      const L = this.L;
      this.hp -= 1; L.hits++;
      this.scatter(this.vx * 0.3, 0);
      L.stop(0.08); L.shake(0.5); L.flashScreen(0.22, C.hazard);
      if (this.hp <= 0) { this.die(true); return; }
      G.audio.sfx('hurt');
      this.gone = true; this.goneT = 0.8;
      if (L.rise && L.rising) L.liquidY += 72;      // the tide backs off a little so one slip is not the end
      if (L.liquidY !== null && this.safe.y + this.h > L.liquidY - 8) { const f = L.findSafe(this.x, this.y); if (f) this.setSafe(f.x, f.y); }
      this.x = this.safe.x; this.y = this.safe.y; this.vx = this.vy = 0; this.dashT = 0; this.atkT = 0; this.ride = null; this.onGround = true;
    }
    die(silent) {
      if (this.dead) return;
      const L = this.L;
      this.dead = true; this.hp = 0;
      if (!silent) this.scatter(this.vx * 0.3, -40);
      L.ring(this.x + 5, this.y + 5, 3, 30, G.hero().hi, 0.4);
      L.stop(0.14); L.shake(0.8);
      G.audio.sfx('die');
      L.events.push('death');
    }

    draw(g, cx, cy) {
      const px = Math.round(this.x + this.w / 2) - cx, py = Math.round(this.y + this.h) - cy;
      for (const a of this.agents) a.draw(g, cx, cy);
      if (this.dead) return;
      if (this.gone) {
        if (this.goneT < 0.34) {                 // pixels knit themselves back together
          const u = Math.max(0, this.goneT / 0.34), k = u * u;
          for (const q of G.heroPixels()) {
            const a = G.hash(q.x, q.y, 5) * 6.28, d = 30 + G.hash(q.y, q.x, 9) * 40;
            g.fillStyle = q.col;
            g.fillRect(Math.round(px + q.x + Math.cos(a) * d * k), Math.round(py + q.y + Math.sin(a) * d * k), 1, 1);
          }
          G.light(px, py - 5, 50, '#ffd9b8', 1 - u, 0.3 * (1 - u));
        }
        return;
      }
      for (const gh of this.ghosts) G.drawHero(g, Math.round(gh.x + 5) - cx, Math.round(gh.y + this.h) - cy, { face: gh.face, col: '#ffd0b8', alpha: gh.life * 3, noEyes: true, sx: gh.sx, sy: gh.sy });
      G.light(px, py - 5, 74, '#ffe6d0', 1, 0.07);
      if (this.inv > 0 && this.hurtT <= 0 && ((this.inv * 20) | 0) % 2) return;
      const o = { face: this.face, sx: this.sx, sy: this.sy };
      const air = !this.onGround;
      if (this.hurtT > 0) { o.eyes = 'hurt'; o.col = '#ffffff'; o.armL = -2; o.armR = -2; o.legs = [2, 1, 1, 2]; }
      else if (this.dashT > 0) { o.eyes = 'shut'; o.legs = [1, 1, 1, 1]; o.col = '#ffe2c4'; }
      else if (air) {
        if (this.wallDir && this.vy > 0) { o.eyeY = 1; if (this.wallDir > 0) o.armR = -2; else o.armL = -2; o.legs = [2, 1, 2, 1]; }
        else if (this.vy < -40) { o.armL = -1; o.armR = -1; o.legs = [2, 2, 2, 2]; o.eyeY = -1; }
        else if (this.vy > 60) { o.armL = -3; o.armR = -3; o.legs = [2, 1, 1, 2]; o.eyeY = 1; }
        else { o.armL = -2; o.armR = -2; o.legs = [1, 2, 2, 1]; }
      } else if (Math.abs(this.vx) > 24) {
        const f = ((this.runT * 13) | 0) % 4;
        o.legs = f === 0 ? [2, 1, 2, 1] : f === 2 ? [1, 2, 1, 2] : [2, 2, 2, 2];
        o.lift = f % 2 ? 0 : -1;
        o.armL = f === 0 ? -1 : f === 2 ? 1 : 0; o.armR = -o.armL;
      } else {
        const breathe = Math.sin(this.t * 2.6) > 0.55;
        if (breathe) { o.lift = 1; o.legs = [1, 1, 1, 1]; }
        if (this.blinkT < 0) o.blink = true;
        if (this.lookT > 0.25) o.eyeY = G.input.down.up ? -1 : 1;
      }
      if (this.celebrate) { o.eyes = 'shut'; o.armL = -3; o.armR = -3; }
      if (this.atkT > 0 && this.atkDir === 'f') o.reach = 3;
      if (this.atkT > 0 && this.atkDir === 'u') { o.armL = -4; o.armR = -4; o.eyeY = -1; }
      G.drawHero(g, px, py, o);
      if (this.atkT > 0) {
        const set = this.tools.opus ? S.slashBig : S.slash, f = this.atkT > 0.115 ? 0 : this.atkT > 0.05 ? 1 : 2, pcy = py - 5;
        const img = this.atkDir === 'u' ? set.u[f] : this.atkDir === 'd' ? set.d[f] : this.atkFace > 0 ? set.f[f] : set.b[f], N = img.width;
        if (this.atkDir === 'u') g.drawImage(img, px - N / 2, pcy - 1 - (N - 3));
        else if (this.atkDir === 'd') g.drawImage(img, px - N / 2, pcy + 1 - 3);
        else if (this.atkFace > 0) g.drawImage(img, px + 1 - 3, pcy - N / 2);
        else g.drawImage(img, px - 1 - (N - 3), pcy - N / 2);
        if (f < 2) G.light(px + (this.atkDir === 'f' ? this.atkFace * 14 : 0), pcy + (this.atkDir === 'u' ? -14 : this.atkDir === 'd' ? 14 : 0), 30, this.tools.opus ? '#ffe27a' : '#ffd0b0', 0.8, 0.3);
      }
    }
  }
  G.Player = Player;
})();

